import { observer } from "mobx-react"
import { Form, Select } from "antd"

import { InputPattern } from "@src/app/components/InputPattern"
import { GlobalCurrenciesCollection } from "@src/app/CurrenciesCollection"
import {
  floatValidator,
  USDPricePattern,
  zeroValidator,
} from "@src/app/validators"
import css from "./index.module.css"

export const FixedPriceFields = observer(() => {
  const currencies = GlobalCurrenciesCollection()

  return (
    <div className={css.wrapper}>
      <Form.Item
        id="GENERATED_ID_FIXEDPRICEFIELDS_FORM_ITEM_VOID_1"
        label={"Amount"}
        name={"amount"}
        rules={[
          {
            message: "Please input amount",
            required: true,
            validator: floatValidator,
          },
          {
            message: "Amount should be greater than 0",
            required: true,
            validator: zeroValidator,
          },
        ]}
        style={{ maxWidth: "100%", width: "75%" }}
      >
        <InputPattern pattern={USDPricePattern} />
      </Form.Item>
      <Form.Item
        id="GENERATED_ID_FIXEDPRICEFIELDS_FORM_ITEM_VOID_2"
        label={"Currency"}
        name="symbol"
        rules={[{ message: "Please select at least one", required: true }]}
        style={{ maxWidth: "100%", width: "25%" }}
      >
        <Select options={currencies.selectOptionsFiat} />
      </Form.Item>
    </div>
  )
})
